(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["TabSlider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Tab slider functionality
    const projectItems = document.querySelectorAll('.project-item');
    const carouselItems = document.querySelectorAll('.carousel-item');

    projectItems.forEach(item => {
      item.addEventListener('click', function(e) {
        if (e.currentTarget.tagName !== 'A') {
          e.preventDefault();
        }

        const index = parseInt(this.getAttribute('data-index'));

        // Remove active class from all items
        projectItems.forEach(el => el.classList.remove('active'));
        carouselItems.forEach(el => el.classList.remove('active'));

        // Add active class to selected items
        this.classList.add('active');
        if (carouselItems[index]) {
          carouselItems[index].classList.add('active');
        }
      });
    });

    // Set first item as active by default
    if (projectItems.length > 0 && carouselItems.length > 0) {
      projectItems[0].classList.add('active');
      carouselItems[0].classList.add('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tabslider_2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Tab slider functionality
    const projectItems = document.querySelectorAll('.project-item2');
    const carouselItems = document.querySelectorAll('.carousel-item2');

    projectItems.forEach(item => {
      item.addEventListener('click', function(e) {
        if (e.currentTarget.tagName !== 'A') {
          e.preventDefault();
        }

        const index = parseInt(this.getAttribute('data-index'));

        // Remove active class from all items
        projectItems.forEach(el => el.classList.remove('active'));
        carouselItems.forEach(el => el.classList.remove('active'));

        // Add active class to selected items
        this.classList.add('active');
        if (carouselItems[index]) {
          carouselItems[index].classList.add('active');
        }
      });
    });

    // Set first item as active by default
    if (projectItems.length > 0 && carouselItems.length > 0) {
      projectItems[0].classList.add('active');
      carouselItems[0].classList.add('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["audit-tabslider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.getElementById('audit-tab-slider');
    if (!section) return;

    const projectItems = section.querySelectorAll('.audit-project-item');
    const carouselItems = section.querySelectorAll('.audit-carousel-item');

    projectItems.forEach((item) => {
      item.addEventListener('click', function (e) {
        if (e.currentTarget.tagName !== 'A') {
          e.preventDefault();
        }

        const index = parseInt(this.getAttribute('data-index'));

        projectItems.forEach((el) => el.classList.remove('active'));
        carouselItems.forEach((el) => el.classList.remove('active'));

        this.classList.add('active');
        if (carouselItems[index]) {
          carouselItems[index].classList.add('active');
        }
      });
    });

    if (projectItems.length > 0 && carouselItems.length > 0) {
      projectItems[0].classList.add('active');
      carouselItems[0].classList.add('active');
    }

    section.addEventListener('click', function (e) {
      const subtitle = e.target.closest('.audit-project-subtitle');
      if (!subtitle) return;

      const details = subtitle.nextElementSibling;
      if (!details || !details.classList.contains('audit-project-subtitle-details')) return;

      e.preventDefault();

      const isActive = subtitle.classList.contains('is-active');

      section.querySelectorAll('.audit-project-subtitle.is-active').forEach(function (activeSubtitle) {
        activeSubtitle.classList.remove('is-active');
      });

      if (!isActive) {
        subtitle.classList.add('is-active');
        section.classList.add('has-active-subtitle');
      } else {
        section.classList.remove('has-active-subtitle');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 999px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.header.classList.contains('menu-open')) {
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
